export const enum ApplicationFeatureEvent {
  activate = 'activate',
  deactivate = 'deactivate',
  toggle = 'toggle',
}
